/**
 * Attenuate per-voice velocity as a polyphonic chord grows, so 4 simultaneous
 * sines don't sum to a perceptually ~4× signal. The exponent 0.6 keeps a solo
 * note at 1.0, dyads at ~0.66, four-note chords at ~0.43.
 *
 * Applied per newly-attacking note — held voices keep their original velocity
 * to avoid retriggering clicks when a chord member is added or removed.
 */
export function polyphonyVelocity(voiceCount: number): number {
  if (voiceCount <= 1) return 1
  return 1 / Math.pow(voiceCount, 0.6)
}
